// extracted by mini-css-extract-plugin
module.exports = {"limitMessage":"textCounter__limitMessage___-JefT"};